import React from 'react';

const HistoryCard = ({ entry, onDownload }) => {
  return (
    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <div className="card h-100 border-0 shadow-sm hover:shadow-md transition-shadow">
        <div className="card-body p-2">
          <div className="text-center mb-2">
            <div className="d-flex justify-content-between align-items-center mb-1">
              <i className="bi bi-journal-text text-primary"></i>
              <small className="text-muted badge bg-light px-1 py-0" style={{fontSize: '0.8rem'}}>
                <i className="bi bi-clock me-1"></i>
                {entry.processedAt || 'Sin fecha'}
              </small>
            </div>
            <h6 className="card-title mb-1 text-truncate fw-semibold" 
                style={{fontSize: '0.8rem'}} 
                title={entry.documentType}>
              {entry.documentType}
            </h6>
          </div>
          
          <div className="mb-2">
            <div className="row g-1 text-center">
              <div className="col-6">
                <div className="p-1 bg-primary bg-opacity-10 rounded-1">
                  <div className="fw-bold text-primary" style={{fontSize: '0.75rem'}}>{entry.filesCount}</div>
                  <small className="text-muted d-block" style={{fontSize: '0.65rem'}}>Archivos</small>
                </div>
              </div>
              <div className="col-6">
                <div className="p-1 bg-warning bg-opacity-10 rounded-1">
                  <div className="fw-bold text-warning" style={{fontSize: '0.75rem'}}>{entry.totalPagesProcessed || entry.filesCount}</div>
                  <small className="text-muted d-block" style={{fontSize: '0.65rem'}}>Páginas</small>
                </div>
              </div>
            </div>
          </div>
          
          <button 
            className="btn btn-success btn-sm w-100 d-flex align-items-center justify-content-center py-1"
            onClick={() => onDownload(entry, 'excel')}
            style={{fontSize: '0.7rem'}}
          >
            <i className="bi bi-download me-1"></i>
            Excel
          </button>
        </div>
      </div>
    </div>
  );
};

const ExtractionHistory = ({ extractionHistory, onDownload, onClearHistory }) => {
  if (extractionHistory.length === 0) return null;

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white">
        <div className="d-flex justify-content-between align-items-center">
            <h5 className="col-8 card-title mb-0 me-3">
              <i className="bi bi-clock-history me-2 text-info"></i>
              Historial de Extracciones              
              <span className="badge bg-secondary ms-2">{extractionHistory.length}</span>
            </h5>            
       
          <button 
            className="btn btn-sm btn-outline-danger"
            onClick={onClearHistory}
          >
            <i className="bi bi-trash me-1"></i>
            Limpiar Historial
          </button>
          
        </div>
      </div>
      <div className="card-body p-2">
        <div className="row g-2">
          {extractionHistory.map((entry) => (
            <HistoryCard
              key={entry.id}
              entry={entry}
              onDownload={onDownload}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExtractionHistory;
